import { render, staticRenderFns } from "./MainConstruction.vue?vue&type=template&id=eaed7d1c&"
import script from "./MainConstruction.vue?vue&type=script&lang=js&"
export * from "./MainConstruction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports